module.exports = __webpack_public_path__ + "img/为工厂降本ico.646cdd4a.png";